// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"a173b791","399":"8b0aedc0","573":"ac968966","588":"e2c6649b","683":"f4dd3f7a","784":"3b1fe5a4","787":"bed44058"}[chunkId] + ".chunk.js";
};